import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import {
  Send as SendIcon,
  Edit as EditIcon,
  History as HistoryIcon,
  Settings as SettingsIcon,
  Analytics as AnalyticsIcon,
  BugReport as TestingIcon,
} from '@mui/icons-material';

interface QuickActionsPanelProps {
  onSendBroadcast: () => void;
  onViewTemplates: () => void;
  onViewHistory: () => void;
  onViewSettings: () => void;
  onViewAnalytics: () => void;
  onViewTesting: () => void;
}

/**
 * QuickActionsPanel Component
 * Panel with common admin notification actions
 */
export const QuickActionsPanel: React.FC<QuickActionsPanelProps> = ({
  onSendBroadcast,
  onViewTemplates,
  onViewHistory,
  onViewSettings,
  onViewAnalytics,
  onViewTesting,
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Quick Actions
        </Typography>
        <Stack spacing={2}>
          <Button
            variant="contained"
            startIcon={<SendIcon />}
            onClick={onSendBroadcast}
            fullWidth
          >
            Send Broadcast
          </Button>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={onViewTemplates}
            fullWidth
          >
            Manage Templates
          </Button>
          <Button
            variant="outlined"
            startIcon={<AnalyticsIcon />}
            onClick={onViewAnalytics}
            fullWidth
          >
            View Analytics
          </Button>
          <Button
            variant="outlined"
            startIcon={<TestingIcon />}
            onClick={onViewTesting}
            fullWidth
          >
            Testing Tools
          </Button>
          <Button
            variant="outlined"
            startIcon={<HistoryIcon />}
            onClick={onViewHistory}
            fullWidth
          >
            View History
          </Button>
          <Button
            variant="outlined"
            startIcon={<SettingsIcon />}
            onClick={onViewSettings}
            fullWidth
          >
            Settings
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
